import { regex } from '@/common/constants/regex.constant';

interface FilterOptionsType {
  removeEmojis?: boolean;
}

interface FilterMethodType {
  removeEmojis: (input: string) => string;
}

const filters: FilterMethodType = {
  removeEmojis: (input: string): string => {
    return input.replace(regex.filterEmojies, '');
  },
};

export const stringFilters = (
  input: string,
  options: FilterOptionsType
): string => {
  let result = input;

  if (options.removeEmojis) {
    result = filters.removeEmojis(result);
  }

  return result;
};
